export default "__VITE_ASSET__BUw4bn_1__"